import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { PisaInputDTO } from 'markets-lib';

import { config } from '../config';
import { prepHeaders } from '../util';

const BASE_PATH = '/api/pisaInput';

export const pisaInputsApi = createApi({
  reducerPath: 'pisaInputs',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: prepHeaders,
  }),
  tagTypes: ['PisaInputs'],
  endpoints: (builder) => ({
    upsert: builder.mutation<PisaInputDTO, PisaInputDTO>({
      query: (payload) => ({
        url: BASE_PATH,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['PisaInputs'],
    }),
    getAll: builder.query<PisaInputDTO[], void>({
      query: () => BASE_PATH,
      providesTags: ['PisaInputs'],
    }),
    getById: builder.query<PisaInputDTO, PisaInputDTO['id']>({
      query: (id) => `${BASE_PATH}/${id}`,
      providesTags: ['PisaInputs'],
    }),
    remove: builder.mutation<PisaInputDTO[], PisaInputDTO['id']>({
      query: (id) => ({
        url: `${BASE_PATH}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PisaInputs'],
    }),
  }),
});

export const {
  endpoints,
  middleware,
  reducer,
  reducerPath,
  useUpsertMutation,
  useRemoveMutation,
  useGetAllQuery,
  useGetByIdQuery,
} = pisaInputsApi;
